// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/jesu-joy-melody.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const jesuJoyMelody: Score = {
  slug: "jesu-joy-melody",
  n: 4,
  title: "Jesu, Joy of Man's Desiring \u2014 Melody Line",
  composer: "Johann Sebastian Bach",
  rights: "public-domain",
  publicSafe: true,
  key: "G",
  fifths: 1,
  time: [3, 4],
  tempo: 72,
  staves: 1,
  clefs: ["treble"],
  bars: 25,
  barQuarters: 3.0,
  lowest: 62,
  highest: 79,
  hasLyrics: false,
  jasonNote: "Jesu, Joy of Man's Desiring by Bach is one of my favourite songs of all time and I'd like to introduce you to 3 beats per bar as a time signature.",
  teaches: [
    "first piece in 3/4 \u2014 three beats per bar",
    "an unbroken crotchet line, one note per beat",
    "dotted minims tied across barlines at the close"
  ],
  art: "/sight-reading/art/jesu-joy-melody.jpg",
  artRights: "public-domain",
  background: "/sight-reading/bg/jesu-joy-melody.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 2, hand: "rh", start: 3.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 3, hand: "rh", start: 6.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 3, hand: "rh", start: 7.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 4, hand: "rh", start: 9.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 4, hand: "rh", start: 10.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter" },
    { bar: 4, hand: "rh", start: 11.0, dur: 1.0, midi: 78, pitch: "F#5", d: "quarter" },
    { bar: 5, hand: "rh", start: 12.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter" },
    { bar: 5, hand: "rh", start: 13.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 5, hand: "rh", start: 14.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 6, hand: "rh", start: 15.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 6, hand: "rh", start: 16.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 6, hand: "rh", start: 17.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 7, hand: "rh", start: 18.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 7, hand: "rh", start: 19.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 7, hand: "rh", start: 20.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 8, hand: "rh", start: 21.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 8, hand: "rh", start: 22.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 8, hand: "rh", start: 23.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 9, hand: "rh", start: 24.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 9, hand: "rh", start: 25.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 9, hand: "rh", start: 26.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 10, hand: "rh", start: 27.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    { bar: 10, hand: "rh", start: 28.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 10, hand: "rh", start: 29.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 11, hand: "rh", start: 30.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 11, hand: "rh", start: 31.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    { bar: 11, hand: "rh", start: 32.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 12, hand: "rh", start: 33.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 12, hand: "rh", start: 34.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 12, hand: "rh", start: 35.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 13, hand: "rh", start: 36.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 13, hand: "rh", start: 37.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 13, hand: "rh", start: 38.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 14, hand: "rh", start: 39.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 14, hand: "rh", start: 40.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 14, hand: "rh", start: 41.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 15, hand: "rh", start: 42.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 15, hand: "rh", start: 43.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 15, hand: "rh", start: 44.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 16, hand: "rh", start: 45.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 16, hand: "rh", start: 46.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter" },
    { bar: 16, hand: "rh", start: 47.0, dur: 1.0, midi: 78, pitch: "F#5", d: "quarter" },
    { bar: 17, hand: "rh", start: 48.0, dur: 1.0, midi: 79, pitch: "G5", d: "quarter" },
    { bar: 17, hand: "rh", start: 49.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 17, hand: "rh", start: 50.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 18, hand: "rh", start: 51.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 18, hand: "rh", start: 52.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 18, hand: "rh", start: 53.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 19, hand: "rh", start: 54.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter" },
    { bar: 19, hand: "rh", start: 55.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 19, hand: "rh", start: 56.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 20, hand: "rh", start: 57.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 20, hand: "rh", start: 58.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 20, hand: "rh", start: 59.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 21, hand: "rh", start: 60.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter" },
    { bar: 21, hand: "rh", start: 61.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 21, hand: "rh", start: 62.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    {
  bar: 22,
  hand: "rh",
  start: 63.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "start"
},
    {
  bar: 23,
  hand: "rh",
  start: 66.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "both"
},
    {
  bar: 24,
  hand: "rh",
  start: 69.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "both"
},
    {
  bar: 25,
  hand: "rh",
  start: 72.0,
  dur: 3.0,
  midi: 67,
  pitch: "G4",
  d: "half",
  dot: true,
  tie: "stop"
},
  ],
};
